import { Icon } from '@platform/components';
import { isTypeNavigationCard, TypeNavigationCardSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';
import { legacyIconsToNewIcons } from './util/legacy-icons';

const ContentfulNavigationCard = ({
  entry,
}: {
  entry: Entry<TypeNavigationCardSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeNavigationCard(entry)) {
    return null;
  }

  console.log('> ', entry.fields.icon);
  const icon = entry.fields.icon && legacyIconsToNewIcons[entry.fields.icon];

  return (
    <a
      className='bg-white sm:min-h-25 shadow rounded-sm flex-grow p-5 transition duration-200 ease-in-out hover:-translate-y-2 hover:shadow-lg'
      href={entry.fields.url}
      target={entry.fields.openInNewTab ? '_blank' : '_self'}
    >
      <h3 className='flex gap-2 text-xl font-semibold items-center'>
        {icon && icon !== 'linked-in' && <Icon type={icon} size='24' />}
        {/* The LinkedIn icon is odd in that you need to render a larger viewbox than expected */}
        {icon === 'linked-in' && <Icon type={icon} size='24' viewbox='0 0 32 32' />}
        <span>{entry.fields.header}</span>
      </h3>
      {entry.fields.description}
      {/* TODO: Revisit when you find examples of these */}
      {/*{entry.fields.image && (
        <img src={entry.fields.image.fields.file?.url} alt={entry.fields.image.fields.title} />
      )}
      {entry.fields.label}*/}
      {/* TODO: Revisit when you find an example of this */}
      {/*{`Has green separator: ${entry.fields.hasGreenSeparator ? 'Yes' : 'no'}`}*/}
    </a>
  );
};

export default ContentfulNavigationCard;
